import { Box } from "@mui/material";
import ClientContent from "./components/clientContent";

const ClientConnectPage = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 6 },
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <ClientContent />
    </Box>
  );
};

export default ClientConnectPage;
